import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

// Card de navegação da home Versão B: ilustração grande + título roxo + subtítulo
// curto + botão de seta colorido. Quando comingSoon, não é clicável e mostra selo
// "Em breve".
export function HomeNavCard({ to, illustration, title, subtitle, accent, comingSoon, count }) {
  const inner = (
    <>
      {count > 0 && (
        <span
          className="absolute right-4 top-4 flex h-6 min-w-6 items-center justify-center rounded-full bg-[#FF5630] px-1.5 text-xs font-extrabold text-white shadow-sm"
          aria-label={`${count} pendências`}
        >
          {count}
        </span>
      )}

      {/* Ilustração principal do card */}
      <img
        src={illustration}
        alt=""
        aria-hidden="true"
        className="mb-2 h-16 w-16 object-contain drop-shadow-sm"
      />

      <span
        className="block text-base font-extrabold"
        style={{ color: '#222731' }}
      >
        {title}
      </span>
      {subtitle && <span className="mt-0.5 block text-xs font-medium leading-snug text-neutral-500">{subtitle}</span>}

      {comingSoon ? (
        <Badge
          variant="muted"
          className="absolute bottom-4 right-4 rounded-full px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide"
        >
          Em breve
        </Badge>
      ) : (
        <span
          aria-hidden="true"
          className="absolute bottom-4 right-4 flex h-9 w-9 items-center justify-center overflow-hidden rounded-full text-white transition-transform duration-100 group-hover:translate-x-0.5"
          style={{
            background: accent.arrow,
            boxShadow: `0 3px 0 color-mix(in srgb, ${accent.arrow} 72%, #000), 0 4px 8px rgba(0,0,0,0.18)`
          }}
        >
          {/* Brilho no topo: dá o aspecto 3D/chanfrado igual ao botão da trilha */}
          <span
            aria-hidden="true"
            className="pointer-events-none absolute inset-x-0 top-0 h-1/2"
            style={{ background: 'linear-gradient(180deg, rgba(255,255,255,0.28) 0%, transparent 100%)' }}
          />
          <FiArrowRight className="relative h-4 w-4" />
        </span>
      )}
    </>
  );

  const baseClass = cn('group relative flex min-h-[140px] flex-col rounded-[20px] p-5 shadow-card', !comingSoon && 'transition-[transform,box-shadow] duration-150 ease-out-strong hover:-translate-y-0.5 hover:shadow-card-hover active:scale-[0.99]');

  if (comingSoon) {
    return (
      <div
        className={baseClass}
        style={{ background: accent.bg }}
      >
        {inner}
      </div>
    );
  }

  return (
    <Link
      to={to}
      className={baseClass}
      style={{ background: accent.bg }}
    >
      {inner}
    </Link>
  );
}
